import React from 'react';
import { motion } from 'framer-motion';
export function LandFreedom() {
  return <section className="py-20 bg-[#E8DCC4]/20" data-id="element-96">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-98">
          <div className="w-full md:w-1/2 order-2 md:order-1" data-id="element-99">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="relative rounded-lg overflow-hidden shadow-xl" data-id="element-100">
              <img src="https://cdn.magicpatterns.com/uploads/kEPxi54YtXiZwjgvbznZEq/Screenshot_2026-01-19_at_11.54.01_AM.png" alt="Desert wildflowers and natural landscape" className="w-full h-auto object-cover" data-id="element-101" />
            </motion.div>
          </div>

          <div className="w-full md:w-1/2 order-1 md:order-2" data-id="element-102">
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-103">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D2D2D] mb-6" data-id="element-104">
                Land, Freedom & <br data-id="element-105" />
                <span className="text-[#C1694F]" data-id="element-106">Infinite Possibilities</span>
              </h2>
              <div className="space-y-6 text-gray-700" data-id="element-107">
                <p className="text-lg" data-id="element-108">
                  In a world of shrinking lots and strict regulations, this
                  property stands apart. With over 1 acre of usable land and no
                  HOA, you make the rules.
                </p>
                <ul className="space-y-4" data-id="element-109">
                  <li className="flex items-start" data-id="element-110">
                    <span className="w-2 h-2 mt-2 bg-[#C1694F] rounded-full mr-3 flex-shrink-0" data-id="element-111"></span>
                    <span data-id="element-112">
                      <strong data-id="element-113">Zoned for Animals:</strong> Bring your horses,
                      chickens, or goats. The property is fully fenced and
                      ready.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-114">
                    <span className="w-2 h-2 mt-2 bg-[#C1694F] rounded-full mr-3 flex-shrink-0" data-id="element-115"></span>
                    <span data-id="element-116">
                      <strong data-id="element-117">RV Access & Hookups:</strong> Dedicated parking
                      pad with full hookups for your rig or visiting guests.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-118">
                    <span className="w-2 h-2 mt-2 bg-[#C1694F] rounded-full mr-3 flex-shrink-0" data-id="element-119"></span>
                    <span data-id="element-120">
                      <strong data-id="element-121">Expansion Ready:</strong> Pre-graded pad for a
                      guest casita or additional storage structure.
                    </span>
                  </li>
                </ul>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}